<template>
    <el-main class="container">
        <div class="left-box">
            <el-upload
                class="upload-demo"
                action="#"
                :on-remove="handleRemove" ref="upload" :http-request="handleChange" :show-file-list="false">
                <el-button size="small" type="primary" @click="btnFun(1)" :disabled="rotationObject.rotationChat.length >= 3">上传轮播</el-button>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
            </el-upload>
            <div class="ban-box">
                <div v-for="(item, index) in rotationObject.rotationChat">
                    <el-image
                        style="width: 300px; height: 300px"
                        fit="contain"
                        :src="item" 
                        :preview-src-list="rotationObject.rotationChat">
                    </el-image>
                    <div>
                        <el-button type="danger" size="mini" @click="delImg(1, index)">删除</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="right-box">
            <el-upload
                class="upload-demo"
                action="#"
                :on-remove="handleRemove" ref="upload" :http-request="handleChange" :show-file-list="false">
                <el-button size="small" type="primary" @click="btnFun(2)">上传大图</el-button>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
            </el-upload>
            <div class="ban-box">
                <div v-if="rotationObject.coverUrl">
                    <el-image
                        style="width: 300px; height: 300px"
                        fit="contain"
                        :src="rotationObject.coverUrl"
                        :preview-src-list="[rotationObject.coverUrl]">
                    </el-image>
                    <div>
                        <el-button type="danger" size="mini" @click="delImg(2)">删除</el-button>
                    </div>
                </div>
            </div>
        </div>
    </el-main>
</template>
<script>
export default {
    name: 'carouselManagement',
    components: {

    },
    data() {
        return {
            addForm: {
                file: {}
            },
            type: 1,
            rotationObject: {
                rotationChat: [],
                id: '',
                coverUrl: ''
            }
        }
    },
    created() {
        this.getvideoimg()
    },
    mounted() {

    },
    methods: {
        async getvideoimg() {
            const { data: res } = await this.$http.get('/erpnew/account/c/reada46ceb/video/lunBoTu')
            console.log(res)
            if(res.code != '0') return this.$message.error('获取数据失败')
            // this.rotationObject = res.data
            if(res.data) {
                this.rotationObject = res.data
            } 
        },
        handleChange(file) {
            console.log(file);
            const raw = file.file
            const isJPG = raw.type === 'image/jpeg' || raw.type === 'image/png';
            const isLt2M = raw.size / 1024 < 500;
            if (!isJPG) {
                this.$refs.upload.clearFiles()
                this.addForm.file = {}
                return this.$message.error('上传图片只能是 JPG/PNG 格式!');
            }
            if (!isLt2M) {
                this.$refs.upload.clearFiles()
                this.addForm.file = {}
                return this.$message.error('上传图片大小不能超过 500KB!');
            }
            this.addForm.file = file.file
            this.uploadHandle()
        },
        handleRemove(file) {
            console.log(file);
        },
        btnFun(type) {
            this.type = type;
        },
        delImg(type, index) {
            if(type == 1) {
                this.rotationObject.rotationChat.splice(index, 1)
                // this.$message({ message: '删除成功', type: 'success' })
            } else {
                this.rotationObject.coverUrl = ''
            }
            this.videoSub()
        },
        async uploadHandle() {
            var formData = new FormData();
            formData.append("file", this.addForm.file);
            const { data: res } = await this.$http.post('/android/AcceptPictureServlet2', formData)
            if (res.code == 'ERROR') {
                loading.close()
                return this.$message.error('图片上传错误')
            }
            if(this.type == 1) {
                this.rotationObject.rotationChat.push(res.result)
            } else {
                this.rotationObject.coverUrl = res.result
            }
            this.videoSub()
        },
        // 上传提交
        async videoSub() {
            const { data: res } = await this.$post(`/erpnew/account/c/reada46ceb/video/${this.rotationObject.id}`, this.rotationObject)
            console.log(res)
            if(res.code != '0') this.$message.error(res.message)
            this.$message({ message: '成功', type: 'success' })
            this.getvideoimg()
        }
    }
}
</script>
<style lang="less" scoped>
    .el-main {
        min-width: 1100px;
        height: 100%;
        display: flex;
        overflow: hidden;
        .left-box {
            width: 50%;
            height: 100%;
            border-right: 1px solid #EBEEF5;
            padding: 10px;
            // text-align: center;
            .ban-box {
                margin-top: 10px;
                display: flex;
                text-align: center;
                flex-wrap: wrap;
                > div {
                    margin-right: 15px;
                }
            }
        }
        .right-box {
            width: 50%;
            height: 100%;
            padding: 10px;
            // text-align: center;
            .ban-box {
                margin-top: 10px;
                display: flex;
                text-align: center;
            }
        }
    }
</style>